import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  headers: { 'Content-Type': 'application/json' }
});

export function getApiOrigin() {
  const base = api.defaults.baseURL || '';
  if (typeof window === 'undefined') {
    return base.startsWith('http') ? new URL(base).origin : '';
  }

  if (base.startsWith('http')) {
    try {
      return new URL(base).origin;
    } catch (e) {
      // ignore et fallback
    }
  }

  return window.location.origin;
}

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('shopmarega_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
